const LotInfoFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "DESCRIPTION_1",
                "tableName": "IMLOT",
                "label": "Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } ,
            {
                "name": "UNITSPERPACKAGEQUANTITY",
                "tableName": "IMLOT",
                "label": "Packages",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "DESCRIPTION_2",
                "tableName": "IMLOT",
                "label": "Description2",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }  ,
            {
                "name": "NETWEIGHTQUANTITY",
                "tableName": "IMLOT",
                "label": "Net Weight",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "DATEEXPIRATION",
                "tableName": "IMLOT",
                "label": "Expiration Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }  ,
            {
                "name": "TAREWEIGHTQUANTITY",
                "tableName": "",
                "label": "Tare Weight",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true
            } 
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_8",
                "tableName": "",
                "label": "Customer Lot",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }  ,
            {
                "name": "GROSSWEIGHTQUANTITY",
                "tableName": "IMLOT",
                "label": "Gross Weight",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    }
];

export default LotInfoFormLayout;
